export default "__VITE_ASSET__CNzWGuws__"